/* eslint-disable import/first */
import $ from "jquery";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "tslib";
// tslint:disable-next-line:ordered-imports
import { addGlobalDebug } from "../utils/any";

// after jQuery
addGlobalDebug("jQuery", $);
addGlobalDebug("$", $);
require("bootstrap");
// tslint:disable-next-line:ordered-imports
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { parse } from "../utils/query-string";

import { getToken } from "../reducers/persist";
import { BugsnagErrorBoundary, FallbackComponentProps } from "../utils/bugsnag";
import { useSelector } from "../utils/types";
import Clock from "./ClockContainer";
import { App } from "./Main";
import { PopupProvider } from "./PopupProvider";
import { AsyncModuleSpinner } from "./Spinner";
import { lazyBundle } from "./Utils";

const ChatPageLazy = React.lazy(() => import("./ChatPage"));
const ClientSignInLazy = React.lazy(() => import("./ClientSignin"));
const LoginPageContainerLazy = React.lazy(() => import("./LoginPage"));
const BetaLandingPageLazy = React.lazy(() => import("./BetaLandingPage"));
const AdminPageLazy = lazyBundle("AdminPage");

if (process.env.NODE_ENV !== "production") {
    if (process.env.REACT_APP_WHY_DID_YOU_UPDATE) {
        const { whyDidYouUpdate } = require("why-did-you-update");
        whyDidYouUpdate(React);
    }
}

export function render(appElement: Element) {
    ReactDOM.render(
        <BugsnagErrorBoundary FallbackComponent={TechnicalDifficulties}>
            <ContextProviders />
        </BugsnagErrorBoundary>,
        appElement
    );
}

function TechnicalDifficulties(_props: FallbackComponentProps) {
    React.useEffect(() => {
        App.protoProxy.destroy();
    }, []);
    return (
        <div className="container text-center">
            {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
            <h1 />
            <div className="well well-lg">
                <h1>Technical Difficulties Are Afoot</h1>

                <h1>PLEASE STANDBY</h1>
            </div>
        </div>
    );
}

export const ContextProviders = () => (
    <Provider store={App.rootStore}>
        <PopupProvider>
            <AsyncModuleSpinner>
                <AppBody />
                <Clock />
            </AsyncModuleSpinner>
        </PopupProvider>
    </Provider>
);

function AppBody() {
    const token = useSelector(getToken);
    const isSignedIn = !!token;

    return (
        <BrowserRouter>
            <Switch>
                <Route
                    path="/client-signin"
                    children={() => <ClientSignInLazy token={token || undefined} />}
                />
                <Route path="/login" children={() => <LoginPageContainerLazy />} />
                <Route
                    path="/"
                    children={({ location }) => {
                        const { page, org_id } = parse(location.search);
                        if (page === "client-signin") {
                            return <ClientSignInLazy token={token || undefined} />;
                        }
                        if (page === "login") {
                            return <LoginPageContainerLazy />;
                        }
                        if (page === "beta-login") {
                            return <BetaLandingPageLazy />;
                        }
                        if (!isSignedIn) {
                            return <LoginPageContainerLazy />;
                        } else {
                            if (page === "admin" && typeof org_id === "string") {
                                return <AdminPageLazy orgId={org_id} />;
                            }
                            return <ChatPageLazy />;
                        }
                    }}
                />
            </Switch>
        </BrowserRouter>
    );
}
